import React, { useState, useEffect, useMemo } from "react"
import { useParams, Link } from "react-router-dom"
import DOMPurify from "dompurify"
import API from "./../../Util/API"
import { ScrollProgressBar } from "../../components/ScrollProgressBar/ScrollProgressBar"
import "./BlogPost.css"





export function BlogPost() {
	const { category, id } = useParams()
	const [postData, setPostData] = useState(null)
	const [relatedPosts, setRelatedPosts] = useState([])
	const [isLoaded, setIsLoaded] = useState(false)
	const api = API()

	const categoryLabels = {
		projects: "Projetos",
		publications: "Publicações",
		resources: "Recursos",
	}

	const categoryTitle = categoryLabels[category] || category

	useEffect(() => {
		setIsLoaded(false)
		window.scrollTo({ top: 0, behavior: "smooth" })

		api
			.get(`${category}/${id}`)
			.then((response) => {
				setPostData(response)
				setIsLoaded(true)
			})
			.catch((error) => {
				console.error(error)
				setIsLoaded(true)
			})

		// Fetch related posts from same category
		api
			.get(`published/${category}`)
			.then((response) => {
				if (Array.isArray(response)) {
					const others = response.filter((item) => item.id !== id).slice(0, 3)
					setRelatedPosts(others)
				}
			})
			.catch(() => {})
	}, [category, id])



	// Sanitize and normalize HTML content
	const sanitizedContent = useMemo(() => {
		if (!postData || !postData.content) return ""

		let rawHtml = postData.content

		// Wrap tables with table-responsive container if not already wrapped
		rawHtml = rawHtml.replace(
			/<table([\s\S]*?)<\/table>/gi,
			'<div class="table-responsive my-3"><table class="table table-bordered table-hover"$1</table></div>'
		)

		// Sanitize with DOMPurify
		const clean = DOMPurify.sanitize(rawHtml, {
			ADD_TAGS: ["iframe"],
			ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "target"],
		})

		return clean
	}, [postData])

	if (!isLoaded) {
		return (
			<main className="page blog-post-loading flex-grow-1 d-flex align-items-center justify-content-center">
				<div className="container text-center py-5 d-flex flex-column align-items-center justify-content-center">
					<div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
						<span className="visually-hidden">Carregando artigo...</span>
					</div>
					<p className="text-muted fw-medium fs-6 mb-0">Carregando conteúdo...</p>
				</div>
			</main>
		)
	}

	if (!postData || (!postData.title && !postData.content)) {
		return (
			<main className="page blog-post-not-found flex-grow-1 d-flex align-items-center justify-content-center">
				<div className="container text-center py-5 d-flex flex-column align-items-center justify-content-center">
					<h2 className="fw-bold text-dark mb-3">Conteúdo não encontrado</h2>
					<p className="text-muted mb-4">O artigo solicitado não existe ou foi removido.</p>
					<Link to={`/${category}`} className="btn btn-primary rounded-pill px-4">
						&larr; Voltar para {categoryTitle}
					</Link>
				</div>
			</main>
		)
	}


	return (
		<React.Fragment>
			<ScrollProgressBar />
			<main className="page blog-post-page flex-grow-1 d-flex flex-column">
				<article className="py-4 flex-grow-1">
					<div className="container">
						{/* Breadcrumbs */}
						<nav aria-label="breadcrumb" className="mb-4">
							<ol className="breadcrumb bg-transparent p-0">

								<li className="breadcrumb-item">
									<Link to="/" className="text-decoration-none">
										Início
									</Link>
								</li>
								<li className="breadcrumb-item">
									<Link to={`/${category}`} className="text-decoration-none">
										{categoryTitle}
									</Link>
								</li>
								{postData.area && (
									<li className="breadcrumb-item">
										<Link to={`/${category}/${postData.area}`} className="text-decoration-none">
											{postData.area}
										</Link>
									</li>
								)}
								<li className="breadcrumb-item active text-truncate text-dark fw-semibold" aria-current="page" style={{ maxWidth: "350px" }}>
									{postData.title}
								</li>
							</ol>
						</nav>

						{/* Article Normalized Content */}
						<div className="article-body-container bg-white shadow-sm border p-4 p-md-5 mb-4">


							<div
								className="blog-post-article-body"
								dangerouslySetInnerHTML={{ __html: sanitizedContent }}
							/>
						</div>




						{/* Related Posts */}
						{relatedPosts.length > 0 && (
							<section className="related-posts-section mt-5 mb-4">
								<h3 className="h4 fw-bold text-dark mb-3">Outros itens em {categoryTitle}</h3>
								<div className="row g-3">
									{relatedPosts.map((related) => (
										<div key={related.id} className="col-12 col-md-4">
											<div className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden">
												{related.imageCover && (
													<img
														src={related.imageCover}
														alt={related.title}
														className="card-img-top"
														style={{ height: "140px", objectFit: "cover" }}
													/>
												)}

												<div className="card-body d-flex flex-column p-3">
													<h6 className="card-title fw-bold text-dark text-truncate mb-2">
														{related.title}
													</h6>
													<p className="card-text text-muted small flex-grow-1" style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
														{related.abstract || "Sem resumo disponível."}
													</p>
													<Link
														to={`/post/${category}/${related.id}`}
														className="btn btn-sm btn-outline-primary mt-2 rounded-pill"
													>
														Ler &rarr;
													</Link>
												</div>
											</div>
										</div>
									))}
								</div>
							</section>
						)}
					</div>
				</article>
			</main>
		</React.Fragment>
	)
}
